<template>
  <div>
    <component v-for="(field, index) in schema"
               :key="index"
               :is="field.fieldType"
               :value="formData[field.name]"
               @input="updateForm(field.label, $event)"
               v-bind="field">
    </component>
  </div>
</template>

<script>
import NumberInput from "./NumberInput";
import SelectList from "./SelectList";
import TextInput from "./TextInput";
import TextAreaInput from "./TextAreaInput";
import DateInput from "./DateInput";
export default {
  name: "FormGenerator",
  components: { NumberInput, SelectList, TextInput, TextAreaInput, DateInput },
  props: ["schema", "value"],
  data() {
    return {
      formData: this.value || {}
    };
  },
  watch:{
    value(newvalue){
      this.formData = this.value || {}
    }
  },
  methods: {
    updateForm(fieldName, value) {
      this.$set(this.formData, fieldName, value);
      this.$emit("input", this.formData);
    }
  }
};
</script>